<template>
  <layout-private :customer="customer">
    <div class="row row-outreach">
      <div class="col-12 col-nav">
        <hr class="hr-salmon">
        <div v-if="$route.name != 'patientDetail'" class="nav-sub-container d-md-flex">
          <h4 class="d-inline d-md-block">Patient Outreach</h4>
          <h4 class="nav-sub-divider d-inline d-md-block">/</h4>
          <br class="d-md-none">
          <ul class="mt-3 mt-md-0 nav nav-tabs nav-sub flex-column flex-md-row">
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'patientOutreachUnscheduled' }"
                :to="{ name: 'patientOutreachUnscheduled' }"
              >
                Unscheduled
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'patientOutreachSnoozed' }"
                :to="{ name: 'patientOutreachSnoozed' }"
              >
                Snoozed
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'patientOutreachCompleted' }"
                :to="{ name: 'patientOutreachCompleted' }"
              >
                Completed
              </router-link>
            </li>
            <li class="nav-item d-flex">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'patientOutreachScheduled' }"
                :to="{ name: 'patientOutreachScheduled' }"
              >
                Scheduled
              </router-link>
              <p class="snug">
                <i class="fal fa-info-circle fa-tooltip fa-tooltip-left outreach-scheduled-tooltip" aria-label="How scheduled status is determined">
                  <span class="tip">
                    <p>A patient is considered scheduled only when their next future scheduled appointment contains a qualifying procedure. Appointments scheduled for today do not count.</p>
                    <p><strong>Stage 1:</strong> D0150 (comprehensive exam).</p>
                    <p><strong>Stage 2:</strong> D0120 or D0150 (recare or comprehensive exam).</p>
                    <p><strong>Stage 3:</strong> An advancing or rebuilding procedure.</p>
                    <p><strong>Stage 4:</strong> An advancing procedure.</p>
                    <p><strong>Stage 5:</strong> A rebuilding procedure.</p>
                    <p><strong>Stage 6:</strong> D0120 or D0150 (recare or comprehensive exam).</p>
                    <p>If the next appointment has no qualifying procedure, the patient is not marked as scheduled for their stage.</p>
                  </span>
                </i>
              </p>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'patientOutreachAll' }"
                :to="{ name: 'patientOutreachAll' }"
              >
                All
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </layout-private>
</template>

<script>
import LayoutPrivate from '../components/LayoutPrivate.vue'

export default {
  props: ['customer'],
  components: {
    LayoutPrivate,
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.row-outreach{
  padding-bottom: 50px;
}

.outreach-scheduled-tooltip {
  margin-left: 5px;
}


</style>